<template>
    <div
        v-cloak
        class="col-6 col-lg-4 mb-4 mb-lg-0"
    >
        <div class="card">
            <img
                :src="`${series.image}?w=300`"
                class="card-img-top"
                loading="lazy"
                :alt="series.title"
            />

            <div class="card-body">
                <h5 class="card-title">
                    {{ title }}
                </h5>

                <p
                    v-if="summary"
                    class="card-text"
                    v-html="summary"
                ></p>

                <p class="d-none">
                  {{ translationLanguageCodes }}
                </p>

                <p
                  v-if="! hasTranslation"
                  class="text-danger"
                >
                  {{ $t('series.notAvailableInLanguage') }}
                </p>

                <router-link
                    :to="`/series/${series.id}`"
                    class="card-link"
                >
                    {{ $t('viewLessons') }}
                </router-link>

                <a
                    href="#"
                    class="float-end"
                    :class="{
                        active: isBookmarked,
                    }"
                    data-toggle="tooltip"
                    data-html="true"
                    data-trigger="hover"
                    :data-original-title="(isBookmarked ? `<i class='fa fa-check'></i> ${$t('favouriteAdded')}` : $t('favouriteSeries'))"
                    @click.stop.prevent="bookmark"
                >
                    <span v-if="isBookmarked"><font-awesome-icon class="text-danger" icon="fa-solid fa-heart" /></span>
                    <span v-else><font-awesome-icon icon="fa-solid fa-heart" /></span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { find, kebabCase } from "lodash";
import { chain } from "lodash";

// toast config
const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 2000,
});

export default {
    name: "SeriesItem",

    props: {
        series: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isBookmarked: Boolean(this.series.bookmark),
        };
    },

    computed: {
      locale() {
        return this.$i18n.locale.toLowerCase();
      },

      title() {
        const translation = find(this.series.translations, (row) => (row.language.code.toLowerCase() === this.locale));

        return (translation ? translation.content : this.series.title);
      },

      summary() {
        const translation = find(this.series.summary_translations, (row) => (row.language.code.toLowerCase() === this.locale));

        return (translation ? translation.content : this.series.summary);
      },

      translationLanguageCodes() {
        return chain(this.series.languages)
          .map("code")
          .map(kebabCase)
          .value();
      },

      hasTranslation() {
        return this.translationLanguageCodes.includes(this.$app.locale.toLowerCase());
      },
    },

    methods: {
        bookmark: function () {
            this.isBookmarked = (! this.isBookmarked);

            if (this.isBookmarked) {
                Toast.fire({
                    type: 'success',
                    title: this.$t('favouriteAddedNotification', { title: this.series.title }),
                });
            }

            axios({
                method: 'post',
                url: `/subscriber/api/series/${this.series.id}/bookmark`,
            })
            .catch(() => {
                this.isBookmarked = (! this.isBookmarked);
            });
        },
    },
};

</script>

<style>
    a .fa-heart
    {
        color: #555;
    }

    a.active .fa-heart
    {
        color: #FE616F;
    }
</style>
